import ApiService from '../../../../../services/ApiService'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'
import Utils from '../../../../../Utils/FormatDate'

export default {
  props: {
    checklistId: String,
  },

  components: {
    SignatureScreen,
  },

  async created() {
    this.env = process.env.VUE_APP_BASE_URL
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    if (this.checklistId) {
      await this.printChecklist(this.checklistId)
    }
  },

  data: () => ({
    institution: {},
    option: 0,
    env: '',
    loading: false,
    signatureConfirmDialog: false,
    signatureErrorDialog: false,
    executingSignatureImage: null,
    validatorSignatureImage: null,
    currentChecklist: {},
    checklistItems: [],
    currentUser: {},
    apiService: new ApiService(),
  }),

  methods: {
    async removeValidateChecklist() {
      let valid = false

      if (
        this.institution.userType == 2 ||
        this.currentUser.mainType == 1 ||
        this.institution.userType == 8 ||
        this.currentUser.mainType == 0
      ) {
        valid = true
      }

      if (
        this.currentUser.id == this.currentChecklist.checklist.validatorUserId
      ) {
        valid = true
      }

      if (valid) {
        const checklist = {
          Id: this.currentChecklist.checklist.id,
          ValidatorName: this.currentChecklist.validatorName,
          isValidatorSigned: false,
          ValidatorUserId: null,
        }

        this.validatorSignatureImage = null

        await this.apiService
          .post('checklistServiceOrder/validate', checklist)
          .then((response) => {
            if (response.statusCode === 200) {
              this.printChecklist(checklist.Id)
            }
          })
      } else {
        this.$toast.error('Você não tem permissão para remover validações')
      }
    },

    async validateServiceOrder() {
      if (this.currentUser.signatureImage) {
        this.currentServiceOrder.isValidatorSigned = true
        this.currentServiceOrder.validatorUserId = this.currentUser.id
        await this.apiService
          .post('serviceOrder/edit', this.currentServiceOrder)
          .then((response) => {
            if (response.statusCode == 200) {
              this.getServiceOrder(this.serviceOrderId)
            }
          })
      } else {
        this.signatureErrorDialog = true
      }
    },

    async editChecklist(checklist) {
      await this.apiService
        .post('checklistServiceOrder/validate', checklist)
        .then(() => {
          this.printChecklist(checklist.Id)
        })
    },

    async validateChecklist(data) {
      if (this.option == 0) {
        if (this.currentUser.signatureImage) {
          const checklist = {
            Id: this.currentChecklist.checklist.id,
            isValidatorSigned: true,
            ValidatorUserId: this.currentUser.id,
            validatorName: this.currentChecklist.validatorName,
          }
          this.editChecklist(checklist)
          this.signatureConfirmDialog = false
        } else {
          this.signatureErrorDialog = true
        }
      } else if (this.option == 1) {
        const checklist = {
          Id: this.currentChecklist.checklist.id,
          isValidatorSigned: true,
          ValidatorUserId: this.currentUser.id,
          validatorImage: data,
          validatorName: this.currentChecklist.validatorName,
        }
        this.editChecklist(checklist)
        this.signatureConfirmDialog = false
      } else {
        if (
          this.currentChecklist.checklist &&
          this.currentChecklist.checklist.serviceOrder &&
          this.currentChecklist.checklist.serviceOrder &&
          this.currentChecklist.checklist.serviceOrder.responsibleName
        ) {
          this.apiService
            .get(
              `byName/${this.currentChecklist.checklist.serviceOrder.responsibleName}`
            )
            .then((response) => {
              const checklist = {
                Id: this.currentChecklist.checklist.id,
                isValidatorSigned: true,
                ValidatorUserId: response.content.id,
                validatorName: response.content.name,
              }
              this.editChecklist(checklist)
              this.signatureConfirmDialog = false
            })
        } else {
          this.$toast.error(
            'Nenhum responsável encontrado na Ordem de Serviço!'
          )
        }
      }
    },

    async printChecklist(checklistId) {
      await this.apiService
        .get(`checklistServiceOrder/printChecklist/${checklistId}`)
        .then((response) => {
          this.currentChecklist = response.content
          if (response.content.checklist.isExecutingSigned) {
            this.getUser(response.content.checklist.executingUserId, true)
          }

          if (response.content.checklist.isValidatorSigned) {
            this.getUser(response.content.checklist.validatorUserId, false)
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getUser(userId, isExecuting) {
      await this.apiService
        .get(`user/${userId}`)
        .then((response) => {
          if (isExecuting) {
            if (response.content.signatureImage != null) {
              this.executingSignatureImage = response.content.signatureImage
            }
          } else {
            if (response.content.signatureImage != null) {
              this.validatorSignatureImage = response.content.signatureImage
            }
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async generatePDF() {
      this.apiService
        .post('checklistServiceOrder/print', this.currentChecklist.checklist)
        .then((response) => {
          var pdfResult = `data:application/pdf;base64,${response.content.pdf}`
          const link = document.createElement('a')
          link.href = pdfResult

          let name = 'Checklist'

          if (this.currentChecklist.checklist) {
            if (this.currentChecklist.checklist.equipment)
              name =
                name + this.currentChecklist.checklist.equipment.identification

            if (
              this.currentChecklist.checklist.serviceOrder &&
              this.currentChecklist.checklist.serviceOrder.department
            )
              name =
                name +
                this.currentChecklist.checklist.serviceOrder.department.name
          }

          link.setAttribute(
            'download',
            `${name}_${this.formatDate(
              this.currentChecklist.checklist.createAt
            )}.pdf`
          )
          document.body.appendChild(link)
          link.click()
        })
    },

    formatDateTime(date) {
      if (!date) return
      return Utils.dateTime(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },
  },
}
